import { render, staticRenderFns } from "./MandateSteps.vue?vue&type=template&id=6369206d&scoped=true&"
import script from "./MandateSteps.vue?vue&type=script&lang=js&"
export * from "./MandateSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6369206d",
  null
  
)

export default component.exports